import React, { useEffect, useState } from "react";
import "antd/dist/reset.css";
import "../../assets/css/navigation-item.css";
import initAmplify from "../../Config/aws-exports";
import Header from "./Header";
import SideNav from "./SideNav";
import { useDispatch } from "react-redux";
import { getUserRole } from "../../features/auth/authSlice";

export default function Layout({ children }) {

  const [isCollapse, setIsCollapse] = useState(false);
  const [isMobileNav, setIsMobileNav] = useState(false);
 const dispatch = useDispatch();
  useEffect(() => {
    initAmplify();
    dispatch(getUserRole());
  }, []);


  return (
    <div className="page_container">
      <Header isMobileNav={isMobileNav} setIsMobileNav={setIsMobileNav} />
      <div className="main_container">
        <SideNav isCollapse={isCollapse} setIsCollapse={setIsCollapse} isMobileNav={isMobileNav} setIsMobileNav={setIsMobileNav} />
        <div className={isCollapse ? "content-wrap-collapse" : "content_wrap"}>{children}</div>
      </div>
      {isMobileNav && <div className="bg-grey" onClick={() => setIsMobileNav(!isMobileNav)}> &nbsp; </div>}
    </div>
  );
}
